module.exports = __webpack_public_path__ + "static/daymond-john-b3a5b200cb7e0810104c059a00cd28a3.jpg";